import { TStats, TPath, TResolvedItemsMap, TItem } from '@modules/items';
import { TPermissions } from '@modules/access';
import { TComment } from '@modules/comments';
import { TDocument, TExternalPlacementOfBlock } from '@modules/documents';
import { TFile } from '@modules/files';

// Draft state on the block
export type TInlineBlockDraft = {
  value: string;
  /** External URL. Stored with protocol (`https://…`). Absent when not set. */
  url?: string;
  createdDate: string; // ISO date
};

// A completed version
export type TInlineBlockVersion = {
  id: string;
  value: string;
  url?: string;
  createdDate: string;
  completedDate: string;
  authors: string[];
  note: string;
};

// History of past values
export type TValueHistoryEntry = {
  user: string;
  date: string;
  value: string;
  url?: string;
};

// The full inline-block payload
export type TInlineBlock = {
  _id: string;
  name: string;
  stats: TStats;
  blockTagId?: string;
  draft?: TInlineBlockDraft;
  versions: TInlineBlockVersion[];
  valueHistory: TValueHistoryEntry[];
  resolvedPath: TPath;
  isQm: boolean;
  isFrozen: boolean;
  comments: TComment[];
  type: 'INLINE_BLOCK'; // defined in `TItemType`
  placementsOfBlock: TExternalPlacementOfBlock[];
};

// What useInlineBlock() returns
export type TUseInlineBlockResult = {
  inlineBlock: TInlineBlock;
  permissions: TPermissions;
  resolvedItems: TResolvedItemsMap;
};

export type TSaveInlineBlockResult = {
  draft: TInlineBlockDraft;
  stats: TStats;
};

export type TCompleteInlineBlockResult = {
  version: TInlineBlockVersion;
  stats: TStats;
};

export type TSetTagResult = {
  blockTagId: string | null;
  stats: TStats;
};

// --- helpers
export const isTInlineBlock = (item: TDocument | TFile | TItem | TInlineBlock | undefined): item is TInlineBlock =>
  Boolean(item && (item as TInlineBlock).type === 'INLINE_BLOCK');
